import * as React from 'react';
import get from 'lodash/get';
import OtpScreen from 'components/OtpScreen/OtpScreen';
import { isValidMobileNumber } from 'utils/validators';
import { generateLoginWithOtp } from 'actions/LoginSignupActions/generateLoginOtpActions';
import { verifyLoginWithOtp } from 'actions/LoginSignupActions/verifyLoginOtpActions';
import { getOmnitureLoginId } from '../LoginSignupAnalytics';
import { hideModal } from 'actions/modalActions';
import toastConfig from 'toasts.json';
import { LoginViews } from '../LoginTypes';
import { FINAL_OTP_PATTERN } from 'components/OtpScreen/OtpScreen';
export default class LoginWithOTPView extends React.Component {
    constructor(props) {
        super(props);
        this.handleOTPSubmit = (otp) => {
            const { handleAPIRequest, handleAPIError, handleLoginSuccess, extra, trackOmniture, pageType, loginSource, changeViewHandler } = this.props;
            const userName = get(extra, 'userName', '');
            const payload = {
                userId: isValidMobileNumber(userName) ? `+91${userName}` : userName,
                requestId: get(this.state, 'requestId'),
                otp
            };
            trackOmniture('loginwith_otp_entered', { pageType, loginSource, loginId: getOmnitureLoginId(userName) });
            handleAPIRequest(verifyLoginWithOtp, payload, () => {
                handleAPIRequest(hideModal);
                typeof handleLoginSuccess === 'function' && handleLoginSuccess();
            }, errorRes => {
                const errorCode = get(errorRes, 'error.errorCode');
                const message = get(errorRes, 'error.message');
                // convert error payload as per the common login submit error response.
                let errorPayload = {
                    error: {
                        RESPONSE: {
                            errorCode,
                            message
                        }
                    }
                };
                if (errorCode === 'LOGIN_1011') {
                    trackOmniture('invalid_email_mobile', { pageType, loginSource, loginId: getOmnitureLoginId(userName) });
                }
                else if (errorCode === 'LOGIN_1032') {
                    changeViewHandler({
                        view: LoginViews.LOGIN,
                        extra: {
                            userName,
                            reactivate: true
                        }
                    });
                    trackOmniture('login_deactivated_user', { pageType, loginSource });
                }
                else if (errorCode === 'MAPI_0004') {
                    typeof handleLoginSuccess === 'function' && handleLoginSuccess();
                }
                else if (errorCode === 'LOGIN_1008') {
                    // invalid verification code message
                    trackOmniture('loginwith_otp_incorrect', { pageType, loginSource, loginId: getOmnitureLoginId(userName) });
                }
                else {
                    changeViewHandler({
                        view: LoginViews.LOGIN,
                        extra: {
                            userName
                        }
                    });
                    trackOmniture('login_failed', { pageType, loginSource });
                }
                return handleAPIError(errorPayload);
            }, 'login_otp_success', '', userName);
        };
        this.handleResendOTP = () => {
            const { handleAPIRequest, toast, changeViewHandler, handleAPIError } = this.props;
            const userName = get(this.props, 'extra.userName', '');
            const _reqBody = {
                loginId: isValidMobileNumber(userName) ? `+91${userName}` : userName
            };
            handleAPIRequest(generateLoginWithOtp, _reqBody, res => {
                const requestId = get(res, 'data.requestId', '');
                this.setState({
                    requestId
                });
                toast.show(toastConfig.verificationCodeSentMsg, { userName });
            }, payload => {
                if (get(payload, ['error', 'RESPONSE', 'errorCode']) === 'LOGIN_1004') {
                    return changeViewHandler({
                        view: LoginViews.MESSAGE_INFO,
                        extra: {
                            message: payload.error.RESPONSE.message
                        }
                    });
                }
                return handleAPIError(payload);
            }, 'loginwith_resend_otp_clicked', '', userName);
        };
        this.handleEditClick = (e) => {
            const { changeViewHandler, extra = {} } = this.props;
            const { userName } = extra;
            changeViewHandler({
                view: LoginViews.LOGIN,
                extra: {
                    userName
                }
            }, e);
        };
        this.handleChangeInOTP = (value) => {
            if (!value) {
                return;
            }
            const otp = value.join('');
            if (FINAL_OTP_PATTERN.test(otp)) {
                // Submit the otp automatically once it matches the regex pattern.
                this.handleOTPSubmit(otp);
            }
        };
        this.state = {
            requestId: get(props, 'extra.loginWithOTPRequestId', '')
        };
    }
    render() {
        const { extra = {} } = this.props;
        const { userName = '' } = extra;
        return (<React.Fragment>
				<OtpScreen userName={userName} handleOTPSubmit={this.handleOTPSubmit} handleResendOTP={this.handleResendOTP} handleEdit={this.handleEditClick} handleChangeInOTP={this.handleChangeInOTP} showEditButton/>
			</React.Fragment>);
    }
}
